type ColorPalette = {
  normal: string
  light?: string
  dark?: string
  lv2Dark?: string
}
type ButtonStateStyle = {
  display: string
  backgroundColor: string
  padding: string
  borderRadius: string
  textAlign: string
  border: string
  color: string
  textDecoration: string
  fontWeight: string
  fontFamily: string
  fontSize: string
  cursor: string
}
export type ModalStyle = {
  top: string
  left: string
  "z-index": string
  width: string
  height: string
  background: string
  opacity: string
}
export type ButtonStyle = {
  standard: ButtonStateStyle & {
    [key: string]: any
  }
  secondary: ButtonStateStyle & {
    [key: string]: any
  }
  roundBlue: ButtonStateStyle & {
    [key: string]: any
  }
}
type ParagraphStateStyle = {
  fontSize: string
  fontFamily: string
}
export type ParagraphStyle = {
  para1: ParagraphStateStyle & {
    [key: string]: any
  }
  para2: ParagraphStateStyle & {
    [key: string]: any
  }
  para3: ParagraphStateStyle & {
    [key: string]: any
  }
}
type LinkStateStyle = {
  fontSize: string
  color: string
}
export type LinkStyle = {
  link1: LinkStateStyle & {
    [key: string]: any
  }
  link2: LinkStateStyle & {
    [key: string]: any
  }
  link3: LinkStateStyle & {
    [key: string]: any
  }
  link4: LinkStateStyle & {
    [key: string]: any
  }
}
type HeadingStateStyle = {
  fontFamily: string
}
export type HeadingStyle = {
  h1: HeadingStateStyle & {
    [key: string]: any
  }
  h2: HeadingStateStyle & {
    [key: string]: any
  }
  h3: HeadingStateStyle & {
    [key: string]: any
  }
  h4: HeadingStateStyle & {
    [key: string]: any
  }
}
export type DropdownStyle = {
  minWidth: string
  maxWidth: string
  height: string
  background: string
  border: string
  borderRadius: string
}
export type Theme = {
  fontFamily: string
  fontSize: {
    s: number
    m?: number
    l?: number
  }
  spacing: {
    normal: number
  }
  breakpoints: {
    s: number
    m: number
    l: number
  }
  palette: {
    background: {
      normal: string
      standardDisabled: string
    }
    primary: ColorPalette
    secondary: ColorPalette
    text: {
      primary: ColorPalette
      onPrimary: ColorPalette
      onBackground: ColorPalette
    }
    store: {
      blue: ColorPalette
    }
    grayscale0: ColorPalette
    grayscale1: ColorPalette
    grayscale2: ColorPalette
    grayscale3: ColorPalette
    grayscale4: ColorPalette
    black: ColorPalette
    blue: ColorPalette
    red: ColorPalette
    pale_orange: ColorPalette
    green: ColorPalette
    gold: ColorPalette
    silver: ColorPalette
    bronze: ColorPalette
  }
}
const theme: Theme = {
  fontFamily: "Roboto, Noto Sans SC, Noto Sans TC, sans-serif",
  fontSize: {
    s: 14
  },
  breakpoints: {
    s: 0,
    m: 720,
    l: 1280
  },
  spacing: {
    normal: 8
  },
  palette: {
    background: {
      normal: "#FFFFFF",
      standardDisabled: "#FBC8BA"
    },
    primary: {
      light: "#FBC8BA",
      normal: "#FB5004",
      dark: "#ff7000",
      lv2Dark: "#AF3802"
    },
    secondary: {
      normal: "#EE7800"
    },
    text: {
      primary: {
        normal: "#535251"
      },
      onPrimary: {
        normal: "#FFFFFF"
      },
      onBackground: {
        normal: "#535251"
      }
    },
    store: {
      blue: {
        normal: "#5387C8"
      }
    },
    grayscale0: {
      normal: "#F6F6F6"
    },
    grayscale1: {
      normal: "#EEEEEE"
    },
    grayscale2: {
      normal: "#aaaaaa"
    },
    grayscale3: {
      normal: "#D1D0D0"
    },
    grayscale4: {
      normal: "#9E9E9E"
    },
    black: {
      normal: "#000000"
    },
    blue: {
      normal: "#2765D6"
    },
    red: {
      normal: "#FF0012"
    },
    pale_orange: {
      normal: "#FFA983"
    },
    green: {
      normal: "#00CA4A"
    },
    gold: {
      normal: "#FFDD33"
    },
    silver: {
      normal: "#C0C0C0"
    },
    bronze: {
      normal: "#CD7F32"
    }
  }
}

export default theme
